import { createSlice } from '@reduxjs/toolkit';
export const initialState = {};
export const translationsSlice = createSlice({
  name: 'translations',
  initialState,
  reducers: {}
});
export default translationsSlice.reducer;